import { MinuteSchedule } from "./MinuteSchedule";
export class Scheduler {
    constructor() {
        this._schedules = [];
        this.started = false;
        this.store = null;
    }
    static getInstance() {
        if (this._instance === null) {
            this._instance = new Scheduler();
        }
        return this._instance;
    }
    kickOff() {
        this._schedules.forEach(s => {
            if (s.isReady()) {
                try {
                    s.executeJob();
                }
                finally {
                    s.setNextRun();
                }
            }
        });
    }
    registerSchedules() {
        // this._schedules.push(new PopupSchedule(1, "h", this.store));
        // this._schedules.push(new FillSchedule(1, "m", this.store));
        // this._schedules.push(new RefreshSchedule(15, "m", this.store));
        this._schedules.push(new MinuteSchedule(1, "m", this.store));
        // this._schedules.push(new UpdateStocksSchedule(1, "m", this.store));
        // this._schedules.push(new ClockSchedule(1, "m", this.store));
        // this._schedules.push(new ClearBoardSchedule(12, "h", this.store));
    }
    init(s) {
        this.store = s;
        this.registerSchedules();
    }
    start() {
        if (this.store == null)
            throw "The scheduler has not been inialized properly";
        if (!this.started) {
            this.timer = setInterval(() => {
                this.kickOff();
            }, 60 * 1000);
            this.started = true;
        }
    }
    stop() {
        clearInterval(this.timer);
        this.started = false;
    }
    getNextRuns() {
        const nextRuns = Array();
        this._schedules.forEach(s => {
        });
        return nextRuns;
    }
}
Scheduler._instance = null;
